import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoadingButton } from "@mui/lab";
import * as React from "react";
import { MetamaskIcon } from "../resources/Icons";
import { useRecoilState } from "recoil";
import { currentMetamaskAddress } from "../store/metamask.store";
import { ethers } from "ethers";
import { Button, TextField, Tooltip } from "@mui/material";

export default function DJ15MessageGenerator() {
  const [loading, setLoading] = React.useState(false);
  const [accountAddress] = useRecoilState(currentMetamaskAddress);
  const [signedValidationMessage, setSignedValidationMessage] = React.useState("");
  const [openCopyTooltip, setOpenCopyTooltip] = React.useState(false);

  const handleSignMessageClick = async () => {
    setLoading(true);
    try {
      if (!accountAddress) return;
      const msgToSign = `I have DJ15 Tokens at ${ethers.utils.getAddress(accountAddress)}`;
      console.log("msgToSign", msgToSign);
      const provider = new ethers.providers.Web3Provider((window as any).ethereum);
      const signer = provider.getSigner();
      const signature = await signer.signMessage(msgToSign);
      const validationMsg = `"${msgToSign}"${signature}`;
      console.log("validationMsg", validationMsg);
      setSignedValidationMessage(validationMsg);
    } catch (error) {
      console.error("Error signing DJ15 token message.", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCopyClick = async () => {
    navigator.clipboard.writeText(signedValidationMessage);
    setOpenCopyTooltip(true);
    setTimeout(() => {
      setOpenCopyTooltip(false);
    }, 1500);
  };

  return (
    <>
      <p className="mb-4 mt-4" style={{ maxWidth: "450px", marginLeft: "auto", marginRight: "auto" }}>
        2. Send a message with a signed message to our DJ15 Bot, then the bot will check your information and register you as a valid member of the group. <br /> <br /> You have around 24 hours to perform this process. You can find an option to generate the signed message and talk to the bot below.
      </p>
      <div className="text-center">
        <LoadingButton
          endIcon={<img style={{ width: 26 }} hidden={loading} src={MetamaskIcon} />}
          loading={loading}
          onClick={handleSignMessageClick}
          sx={{
            backgroundColor: "#EAC249",
            color: "black",
            padding: "12px",
            "&:hover": {
              background: "#F7E6B3",
            },
          }}>
          Sign Validation Message
        </LoadingButton>
      </div>
      {signedValidationMessage && (
        <div style={{ display: "flex", flexDirection: "column", maxWidth: "450px", marginLeft: "auto", marginRight: "auto" }}>
          <p className="mt-4">3. Copy and send the following message to our DJ15Bot to validate your account.</p>
          <TextField
            id="outlined-multiline-static"
            label="Your signed validation message"
            multiline
            rows={4}
            InputProps={{
              readOnly: true,
            }}
            className="input-signed-msg"
            inputProps={{ style: { color: "black", height: "auto", width: "100%", maxWidth: "800px", backgroundColor: "white" } }}
            InputLabelProps={{ style: { color: "white" } }}
            value={signedValidationMessage}
          />
          <Tooltip open={openCopyTooltip} title="Copied!">
            <Button variant="outlined" onClick={handleCopyClick}>
              Copy
            </Button>
          </Tooltip>
          <div className="text-center mt-4 mb-4">
            <a href="https://t.me/DavinciJ15TokenBot" className="btn token-button">
              Talk to DJ15 Bot <FontAwesomeIcon icon={faArrowCircleRight} />
            </a>
          </div>
        </div>
      )}
    </>
  );
}
